// removed by extract-text-webpack-plugin
module.exports = {"vpDescriptionContainer":"vpDescriptionContainer___1AliP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CampaignDescription.module.less
// module id = 2554
// module chunks = 29